var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgToggleOn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 26,
    viewBox: "0 0 48 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_25_23)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1765 0.5H34.8235C41.8309 0.5 47.5 6.10278 47.5 13C47.5 19.8972 41.8309 25.5 34.8235 25.5H13.1765C6.16907 25.5 0.5 19.8972 0.5 13C0.5 6.10278 6.16907 0.5 13.1765 0.5Z",
    fill: "white",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_25_23)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.8236 0.464233H13.1766C6.15932 0.464233 0.470703 6.07666 0.470703 12.9999C0.470703 19.9232 6.15932 25.5357 13.1766 25.5357H34.8236C41.8409 25.5357 47.5295 19.9232 47.5295 12.9999C47.5295 6.07666 41.8409 0.464233 34.8236 0.464233Z",
    fill: "#363636",
    fillOpacity: 0.72
  })), /*#__PURE__*/React.createElement("path", {
    d: "M35 23C40.5228 23 45 18.5228 45 13C45 7.47715 40.5228 3 35 3C29.4772 3 25 7.47715 25 13C25 18.5228 29.4772 23 35 23Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_25_23)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.9999 8.7179C32.635 8.7179 30.7178 10.6351 30.7178 13C30.7178 15.365 32.635 17.2821 34.9999 17.2821C37.3648 17.2821 39.282 15.365 39.282 13C39.282 10.6351 37.3648 8.7179 34.9999 8.7179ZM34.9999 16.5V9.50002C36.6617 9.4956 38.0949 10.6667 38.4217 12.2961C38.526 12.7596 38.526 13.2404 38.4217 13.7039C38.0949 15.3334 36.6617 16.5045 34.9999 16.5Z",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4417 9.55866C38.5139 9.63235 38.6123 9.67449 38.7154 9.67599C38.8186 9.67453 38.917 9.63235 38.9891 9.55866L39.9473 8.60056C40.1201 8.47095 40.155 8.22585 40.0255 8.05306C39.8959 7.88026 39.6508 7.84527 39.478 7.97484C39.4483 7.99707 39.422 8.02341 39.3998 8.05306L38.4416 9.01116C38.2904 9.14986 38.2803 9.38489 38.4191 9.53605C38.4263 9.54391 38.4338 9.55144 38.4417 9.55866Z",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4804 16.4415C31.3413 16.3372 31.1501 16.3372 31.0111 16.4415L30.053 17.3996C29.9018 17.5383 29.8917 17.7733 30.0304 17.9245C30.0376 17.9323 30.0452 17.9399 30.053 17.9471C30.1917 18.0983 30.4267 18.1084 30.5779 17.9696C30.5857 17.9624 30.5933 17.9549 30.6004 17.9471L31.5585 16.9889C31.6881 16.8162 31.6532 16.5711 31.4804 16.4415Z",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9471 17.3995L38.989 16.4414C38.8162 16.3118 38.5711 16.3468 38.4415 16.5196C38.3372 16.6587 38.3372 16.8499 38.4415 16.9889L39.3996 17.947C39.5383 18.0982 39.7733 18.1083 39.9245 17.9696C39.9323 17.9624 39.9399 17.9548 39.947 17.947C40.0982 17.8083 40.1083 17.5733 39.9696 17.4221C39.9625 17.4142 39.9549 17.4067 39.9471 17.3995Z",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0109 9.55866C31.1497 9.70986 31.3847 9.71997 31.5358 9.58123C31.5437 9.57404 31.5512 9.56648 31.5584 9.55866C31.7096 9.41996 31.7197 9.18493 31.581 9.03377C31.5738 9.02591 31.5662 9.01838 31.5584 9.0112L30.6003 8.0531C30.4275 7.92349 30.1824 7.95852 30.0528 8.13132C29.9485 8.27035 29.9485 8.46156 30.0528 8.6006L31.0109 9.55866Z",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0004 8.13129C35.2164 8.13129 35.3915 7.95621 35.3915 7.74023V6.39106C35.3915 6.17508 35.2164 6 35.0004 6C34.7845 6 34.6094 6.17508 34.6094 6.39106V7.74023C34.6094 7.95621 34.7845 8.13129 35.0004 8.13129Z",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0004 17.8688C34.7845 17.8688 34.6094 18.0439 34.6094 18.2598V19.609C34.6094 19.825 34.7845 20.0001 35.0004 20.0001C35.2164 20.0001 35.3915 19.825 35.3915 19.609V18.2598C35.3915 18.0439 35.2164 17.8688 35.0004 17.8688Z",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6094 12.609H40.2602C40.0442 12.609 39.8691 12.7841 39.8691 13.0001C39.8691 13.2161 40.0442 13.3911 40.2602 13.3911H41.6094C41.8254 13.3911 42.0004 13.2161 42.0004 13.0001C42.0004 12.7841 41.8253 12.609 41.6094 12.609Z",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1313 13.0001C30.1313 12.7841 29.9562 12.609 29.7402 12.609H28.3911C28.1751 12.609 28 12.7841 28 13.0001C28 13.2161 28.1751 13.3911 28.3911 13.3911H29.7402C29.9562 13.3911 30.1313 13.2161 30.1313 13.0001Z",
    fill: "#252525"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_25_23",
    x: -57.5293,
    y: -51.5358,
    width: 163.059,
    height: 151.071,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 16
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 29
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0341667 0 0 0 0 0.0408 0 0 0 0 0.2 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_25_23"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0352941 0 0 0 0 0.0392157 0 0 0 0 0.2 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_25_23",
    result: "effect2_dropShadow_25_23"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_25_23",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25_23"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 26,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_25_23"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(28 6)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleOn);
export default __webpack_public_path__ + "static/media/ToggleOn.a415d80930fe7ff812455f8d589fd27b.svg";
export { ForwardRef as ReactComponent };